import React, { FunctionComponent } from "react";
import { Box, ResponsiveLayout, Typography } from "@bca/ui-library";
import { border, BorderProps } from "styled-system";
import styled from "styled-components";

import { LotNavigation } from "../../vehicleDetails/vehicle-details-props.type";
import useDeviceType from "../../hooks/useDeviceType.hook";
import useSourcePage from "../../hooks/useSourcePage";
import LotNavigationButton from "./LotNavigationButton";

const StyledNavigationBanner = styled(Box)<BorderProps>`
  z-index: 3;
  bottom: 0;
  left: 0;
  position: fixed;
  margin-top: 15px;
  box-shadow: 0 0 25px 0 rgba(218, 218, 218, 0.5);
  ${border}
`;

interface LotNavigationProps {
  navigation?: LotNavigation;
  description: string;
}

const LotNavigationBanner: FunctionComponent<LotNavigationProps> = ({
  navigation,
  description,
}) => {
  const { isMobileDevice } = useDeviceType();
  const { isVPSourcePage, isVPSoldSourcePage, isNewSearchPage } =
    useSourcePage();

  const existsNavigationData = () => {
    const isFirstLot = navigation?.index === 1 && navigation?.nextLotLink;

    const isLastLot =
      navigation?.index === navigation?.totalCount &&
      navigation?.previousLotLink;

    const isIntermediateLot =
      navigation?.index > 1 &&
      navigation?.index < navigation?.totalCount &&
      navigation?.previousLotLink &&
      navigation?.nextLotLink;

    const isSingleLot = navigation?.index === 1 && navigation?.totalCount === 1;

    return isFirstLot || isLastLot || isIntermediateLot || isSingleLot;
  };

  const shouldShowLotNavigation =
    ((isVPSourcePage && !isVPSoldSourcePage) || isNewSearchPage) &&
    existsNavigationData();

  return (
    <>
      {shouldShowLotNavigation && (
        <StyledNavigationBanner
          backgroundColor="primary-white"
          width="100%"
          height="100px"
          display="flex"
          flexDirection="row"
          border="normalBorder"
          data-testid="lot-navigation-banner"
        >
          <ResponsiveLayout
            display="flex"
            flexDirection={isMobileDevice ? "column" : "row"}
            justifyContent={isMobileDevice ? "space-evenly" : "space-between"}
            alignItems="center"
          >
            <Typography
              color="black"
              margin={0}
              textAlign="center"
              variant={isMobileDevice ? "body" : "body-large"}
              fontWeight="medium"
            >
              {description}
            </Typography>
            <Box
              backgroundColor="transparent"
              display="flex"
              alignItems="center"
              flexWrap="nowrap"
            >
              <LotNavigationButton
                prevVrm={navigation.previousLotLink}
                direction="previous"
                index={navigation.index}
                totalCount={navigation.totalCount}
              />
              <Typography
                variant="body-small"
                fontWeight="medium"
                css="white-space:nowrap"
                color="footer-blue"
                margin={2}
                data-testid="lot-navigation-number"
              >
                Lot {navigation.index}/{navigation.totalCount}
              </Typography>
              <LotNavigationButton
                nextVrm={navigation.nextLotLink}
                direction="next"
                index={navigation.index}
                totalCount={navigation.totalCount}
              />
            </Box>
          </ResponsiveLayout>
        </StyledNavigationBanner>
      )}
    </>
  );
};

export default LotNavigationBanner;
